import $ from 'jquery';
import _ from 'underscore';
import segmentanalytics from 'lib/segmentio/analytics';
import Raven from 'util/raven';
import * as Avo from 'util/avo';
import {
    $window,
    jqGetElemById,
    isAndroid,
    isIos,
    userIsAuthenticated,
    thirdPartyCookiesEnabled,
} from 'util/global';
import { getParamsObject } from 'util/urls';


/** @module */
const tracking = {};

// This is a gargoyle switch.
tracking.useAvo = document.body.classList.contains('use_avo');


/**
 * Will be replaced with a real logging function if logging is enabled
 */
var analyticsLog = function () { };

/**
 * Loads Segment
 * @param {Object} data - analytics data
 */
var loadSegment = function (data) {
    tracking.segmentKey = data.segmentKey;

    // NOTE: this config is duplicated in templates/api_webviews/solvable/analytics.html
    // if you change anything here you must also change it there
    segmentanalytics.initialize({
        "Amplitude": {
            "apiKey": data.amplitudeKey,
            "eventUploadThreshold": 30,
            "saveParamsReferrerOncePerSession": true,
            "trackCategorizedPages": false,
            "trackGclid": true,
            "trackReferrer": true,
            "eventUploadPeriodMillis": 30000,
            "deviceIdFromUrlParam": false,
            "trackAllPages": false,
            "trackNamedPages": false,
            "trackSessionEvents": false,
            "trackUtmProperties": true,
            "batchEvents": false,
            "mapQueryParams": {},
            "useLogRevenueV2": true,
            "forceHttps": true
        },
        "Segment.io": {
            "apiKey": data.segmentKey,
            "segmentUrl": data.segmentUrl,
            "addBundledMetadata": true,
            "unbundledIntegrations": []
        }
    });

    handleCampaignTags();
};

/**
 * Loads Google Analytics
 * @param {Object} data - analytics data
 */
var loadGoogleAnalytics = function (data) {
    var gaKey = 'UA-33841253-1';
    if (!data.isNative || window.location.pathname.indexOf('/wiki/') === 0) {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date(); a = s.createElement(o),
                m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.parkandroid.com/analytics.js', 'ga');

        // Switch which of these two is commented out, for localhost testing
        window.ga('create', gaKey, 'auto');
        // window.ga('create', gaKey, {'cookieDomain': 'none'});

        window.ga('require', 'displayfeatures');
        window.ga('send', 'pageview');
    } else {
        window.ga = function () { };
    }
};

/** Loads Google Tag Manager snippet */
function loadGoogleTagManager() {
    (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                'https://www.parkandroid.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-5RMLTZ4');
}

/**
 * Loads Facebook Pixel
 * @param {Object} data - analytics data
 */
var loadFacebookPixel = function (data) {
    if (!data.isNative && data.isTrackedUser) {
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            }; if (!f._fbq) f._fbq = n;
            n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
        }(window,
            document, 'script', '//connect.facebook.net/en_US/fbevents.js');

        window.fbq('init', data.facebookAdPixelId);  // see settings.py for pixel ID
        window.fbq('track', 'PageView');

        if (data.signedUp) {
            window.fbq('track', 'CompleteRegistration');
        } else if (data.viewedPaywall) {
            window.fbq('trackCustom', 'BViewPaywall');
        } else if (data.contentType) {
            window.fbq('track', 'ViewContent', {
                'type': data.contentType,
                'slug': data.slug,
                'topic': data.topic
            });
        }

        // facebook pixel for B^2 purchase tracking
        if (data.ltvEventId) {
            var ltvData = {
                value: data.ltvEventLtv,
                currency: data.ltvEventCurrency
            };

            window.fbq('track', 'Purchase + Trial conversion', ltvData, {eventID: `combined_ltv_${data.ltvEventId}`});
            _.defer(() => {
                tracking.track('facebook_pixel_purchase', ltvData);  // segment
            });
            $.get(data.ltvEventConfirmUrl, function (d) {  // backend
                analyticsLog('ltvEvent:confirm', d.success);
            });
        }
    } else {
        window.fbq = function () { };
    }
};

/**
 * Load the Quantcast conversion pixel
 * @param {Object} data - analytics data
 */
function loadQuantcastPixel(data) {
    if (data.isNative || !data.isTrackedUser) {
        return;
    }

    window._qevents = window._qevents || [];

    _.defer(() => {
        let elem = document.createElement('script');
        elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";
        elem.async = true;
        elem.type = "text/javascript";
        const scpt = document.getElementsByTagName('script')[0];
        scpt.parentNode.insertBefore(elem, scpt);
    });

    tracking.quantcastTrack('PageView');
}

tracking.quantcastTrack = function(eventName, planInterval = null) {
    // Product category is only for the Purchase event
    const quantcastProductCategory = planInterval ? `,_fp.pcat.${planInterval}` : "";
    window._qevents = window._qevents || [];
    window._qevents.push({
        qacct: 'p-FKUf-aSLZvzn7',
        labels: `_fp.event.${eventName},_fp.userid.${tracking.identity}${quantcastProductCategory}`,
        event: 'refresh',
    });
}

/**
 * Load the Tatari conversion pixel
 * @param {Object} data - analytics data
 */
function loadTatariPixel(data) {
    if (data.isNative || !data.isTrackedUser) {
        return;
    }

    _.defer(() => {
        !function(){try{!function(t,i){if(!i.version){window.tatari=i,i.init=function(t,n){var e=function(t,n){i[n]=function(){t.push([n].concat(Array.prototype.slice.call(arguments,0)))}};"track pageview identify".split(" ").forEach(function(t){e(i,t)}),i._i=t,i.config=n,i.pageview()},i.version="1.2.1";var n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://d2hrivdxn8ekm8.cloudfront.net/tag-manager/9c1e4a78-0032-4b05-ad81-bc931326ee4d-latest.js";var e=t.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)}}(document,window.tatari||[])}catch(t){console.log(t)}}(); tatari.init('9c1e4a78-0032-4b05-ad81-bc931326ee4d');
    });

    if (data.signedUp) {
        tatariIdentify(tracking.identity);
    }
}

function tatariIdentify(identity) {
    try {
        window.tatari.identify(identity);
    } catch (e) {
        // NOP
    }
}

tracking.tatariTrack = function(eventName, eventData = null) {
    try {
        window.tatari.track(eventName, eventData);
    } catch (e) {
        // NOP
    }
}

/**
 * Load the Google conversion pixel and track onload events
 * @param {Object} data - analytics data
 */
var loadGooglePixel = function (data) {
    if (data.isNative || !data.isTrackedUser) {
        return;
    }

    tracking.googleAdPixelId = data.googleAdPixelId;

    // track onload events
    $.getScript('https://www.googleadservices.com/pagead/conversion_async.js')
        .then(function () {
            // track all pageviews
            var params = {
                'google_conversion_label': 'MKTlCLCW5mYQlcS-4AM'        // Browser any pageview including logged out (remarketing)
            }
            if (data.tries) {
                params['google_custom_params'] = {
                    'tries_made': data.tries
                }
            }
            trackGooglePixel(params, true);
            trackGooglePixel({
                'google_conversion_label': 'aSZbCPfA1G4QlcS-4AM'        // Browser any pageview including logged out (conversions)
            });

            // track specials events
            if (data.signedUp) {
                trackGooglePixel({
                    'google_conversion_label': 'hB7HCPSF6WYQlcS-4AM'    // Browser signup (remarketing)
                }, true);
                trackGooglePixel({
                    'google_conversion_label': 'V4rMCOzSwG4QlcS-4AM'    // Browser signup (conversions)
                });
            } else if (data.viewedPaywall) {
                trackGooglePixel({
                    'google_conversion_label': 'wsH9CLmN5mYQlcS-4AM'    // Browser viewed paywall including logged out (remarketing)
                }, true);
                trackGooglePixel({
                    'google_conversion_label': 'sXGXCOzVwG4QlcS-4AM'    // Browser viewed paywall including logged out (conversions)
                });
            } else if (data.contentType) {
                trackGooglePixel({
                    'google_conversion_label': 't-2DCIvQ2GYQlcS-4AM',   // Browser viewed content logged in (remarketing)
                    'google_custom_params': {
                        'type': data.contentType,
                        'slug': data.slug,
                        'topic': data.topic
                    }
                }, true);
                trackGooglePixel({
                    'google_conversion_label': '1wqUCOeO2m4QlcS-4AM'   // Browser viewed content logged in (conversions)
                });
            }

            // track purchases
            if (data.ltvEventId) {
                trackGooglePixel({
                    'google_conversion_label': 'mpVwCOaK5mYQlcS-4AM',   // Browser purchase (remarketing)
                    'google_conversion_value': data.ltvEventLtv,
                    'google_conversion_currency': data.ltvEventCurrency,
                    'google_custom_params': {
                        'subscription_interval': data.ltvEventInterval,
                    }
                }, true);
                trackGooglePixel({
                    'google_conversion_label': 'ByXkCJSJ2m4QlcS-4AM',   // Browser purchase (conversions)
                    'google_conversion_value': data.ltvEventLtv,
                    'google_conversion_currency': data.ltvEventCurrency,
                    'google_custom_params': {
                        'subscription_interval': data.ltvEventInterval,
                    }
                });
            }

            // track start trial
            if (data.sendGaTrialSubscriptionEvent) {
                trackGooglePixel({
                    'google_conversion_label': 'ryunCIHCq7YBEJXEvuAD'  // StartTrial (web)
                });
            }

        });
};

/**
 * Track Google converion pixel events
 * @param {Object} params
 */
var trackGooglePixel = (function () {
    var backloggedEvents = [];
    return function (params, remarketing_only) {
        var defaultParams = {
            google_conversion_id: tracking.googleAdPixelId,
            google_conversion_language: 'en',
            google_conversion_format: '3',
            google_conversion_color: 'ffffff'
        };
        if (remarketing_only) {
            defaultParams['google_remarketing_only'] = true;
        } else {
            defaultParams['google_remarketing_only'] = false;
        }
        params = _.extend({}, defaultParams, params);

        if (window.google_trackConversion) {
            if (backloggedEvents.length) {
                backloggedEvents.forEach(function (e) {
                    window.google_trackConversion(e);
                });
                backloggedEvents = [];
            }
            window.google_trackConversion(params);
        } else {
            backloggedEvents.push(params);
        }
    };
})();

/**
 * Sets up CIO object; does not load CIO.
 */
var initCustomerio = function () {
    window._cio = window._cio || [];
    var a, b, c; a = function (f) {
        return function () {
            _cio.push([f].
                concat(Array.prototype.slice.call(arguments, 0)))
        }
    }; b = ["load", "identify",
        "sidentify", "track", "page"]; for (c = 0; c < b.length; c++) { _cio[b[c]] = a(b[c]) };
};

/**
 * Loads CIO if not already loaded
 */
var loadCustomerio = _.once(function () {
    analyticsLog('loadCustomerio', tracking.cioKey);
    var t = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    t.async = true;
    t.id = 'cio-tracker';
    t.setAttribute('data-site-id', tracking.cioKey);
    t.src = 'https://assets.customer.io/assets/track.js';
    s.parentNode.insertBefore(t, s);
});

/**
 * Replaces analyticsLog with a real logging function
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
var initLogging = function (data) {
    if (data.loggingEnabled) {
        analyticsLog = (eventName,...args) => {
            const newArgs = [`[analytics][${eventName}]`, ...args];
            console.log.apply(console, newArgs);
        };
    }
};

/**
 * Parse campaign tags for tracking in Segment
 */
var handleCampaignTags = function () {
    if (window.location.search.search(/(utm|ga)_/) === -1) {
        return;
    }

    var utmKeywords = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'ga_referrer',
        'ga_match',
    ];
    var getparams = getParamsObject();

    var latestProperties = {};
    var currentProperties = {};

    utmKeywords.forEach(function (keyword) {
        latestProperties[keyword + '_latest'] = getparams[keyword] || '-';
        if (keyword in getparams) {
            currentProperties[keyword + '_current'] = getparams[keyword];
        }
    });

    tracking.setSuperProperties(latestProperties);
    tracking.setTemporaryProperties(currentProperties);
};

/**
 * Loop through JS events from the backend and process accordingly
 * @param {JQuery} $container
 */
var handleOnloadEvents = function ($container) {
    $container.children('.ax-event').each(function () {
        var data = $(this).data();
        tracking.track(data.axName, data.axProperties);
    });
};

function handleJsonFromHtml(data) {
    if (typeof (data) === 'string') {
        try {
            data = JSON.parse(data);
        } catch (e) {
            Raven.captureMessage('Error parsing analytics JSON: ' + data);
            data = {};
        }
    }
    for (var prop in data) {
        if (typeof (data[prop]) === 'string') {
            // replace quote placeholders with the real thing
            data[prop] = data[prop].replace(/\[QUOTE\]/g, '"');
            data[prop] = data[prop].replace(/\[SINGLEQUOTE\]/g, "'");
        }
    }
    return data;
}


/**
 * Init analytics data, load 3rd-party libs, process initial events
 * @param {JQuery} $container
 */
tracking.init = function ($container) {
    if (window.nativeAnalyticsDisabled) {
        return;
    }

    let data;
    const { nativeAnalytics } = window;
    if (nativeAnalytics) {
        tracking.analyticsLive = true;
        tracking.mobileNative = true;
        tracking.superProperties = handleJsonFromHtml(nativeAnalytics.initialSuperProperties);
        tracking.userProperties = {};
        tracking.identity = tracking.superProperties.indentity;
        tracking.cioIdentifyData = nativeAnalytics.cioIdentifyData;
        tracking.cioKey = nativeAnalytics.cioKey;
        tracking.displayedContinuePracticingBanner = false;
        tracking.displayedRecommendedCourseBanner = false;
        tracking.recommendedCourseId = null;
        tracking.userIsAuthenticated = nativeAnalytics.userIsAuthenticated;
        tracking.initTrackingFromData(nativeAnalytics, false);
    } else {
        data = $container.data();
        tracking.analyticsLive = data.analyticsLive;
        tracking.identity = data.analyticsIdentity;
        tracking.cioIdentifyData = handleJsonFromHtml(data.cioIdentifyData);
        tracking.cioKey = data.cioKey;
        tracking.superProperties = handleJsonFromHtml(data.analyticsSuperProperties);
        tracking.userProperties = handleJsonFromHtml(data.analyticsUserProperties);
        tracking.displayedContinuePracticingBanner = data.displayedContinuePracticingBanner === true;
        tracking.displayedRecommendedCourseBanner = data.displayedRecommendedCourseBanner === true;
        tracking.recommendedCourseId = data.recommendedCourseId;
        tracking.userIsAuthenticated = userIsAuthenticated;
        tracking.initTrackingFromData(data, thirdPartyCookiesEnabled);
        handleOnloadEvents($container);
    }

    if (tracking.useAvo) {
        // This initializes Avo, which will have each event we want to track as a method. Eg.
        // `Avo.searchResult(properties)` will track the `search_result` event.
        // Under the hood, this will simply call `AvoInterop.logEvent("search_result", properties)`.
        // This in turn is set up to pass this call to the `track` method.
        // Eventually, we may want to have Avo send directly to the analytics gateway.
        //
        // WARNING: the docs say that this function should be called as
        // `Avo.initAvo(options, AvoInterop)`: https://www.avo.app/docs/custom-destinations#javascript
        // But this is a LIE. The function signature from the generated code is
        // `Avo.initAvo(options, systemProperties, destinationOptions, AvoInterop)`.
        // So watch out for changes.
        Avo.initAvo({
            env: tracking.analyticsLive ? 'prod' : 'dev',
            webDebugging: false,
            strict: true,
        }, {}, {}, AvoInterop);
    }
}

// it seems like frontend/utils/analytics.ts can't set module variables directly when dynamically importing
tracking.remoteInit = function(analyticsData, user) {
    tracking.analyticsLive = analyticsData.analytics_live;
    tracking.identity = analyticsData.analytics_identity;
    tracking.cioIdentifyData = analyticsData.cio_identify_data;
    tracking.cioKey = analyticsData.cio_key;
    tracking.superProperties = analyticsData.analytics_super_properties;
    tracking.userProperties = analyticsData.analytics_user_properties;
    tracking.displayedContinuePracticingBanner = false; // TODO
    tracking.displayedRecommendedCourseBanner = false; // TODO
    tracking.recommendedCourseId = null; // TODO
    tracking.userIsAuthenticated = user.is_authenticated;
};

tracking.initTrackingFromData = function (data, includeExtras) {
    try {
        if (Object.keys(tracking.superProperties).length === 0) {
            Raven.captureMessage('Missing backend superProperties');
        }
    } catch (e) {}

    tracking.superProperties.user_agent =
        tracking.superProperties.user_agent || window.navigator.userAgent;
    tracking.temporaryProperties = {};

    if (!tracking.analyticsLive) {
        return;
    }

    initLogging(data);
    loadSegment(data);

    if (includeExtras) {
        loadGoogleAnalytics(data);

        // conversion pixels
        loadFacebookPixel(data);
        loadGooglePixel(data);
        loadQuantcastPixel(data);
        loadTatariPixel(data);
    }

    if(data.ltvEventId) {
        trackGTagEvent('gtag__browser_purchased',  {
            'gtag_value__conversion_value': data.ltvEventLtv,
            'gtag_value__conversion_currency': data.ltvEventCurrency,
            'gtag_value__subscription_interval': data.ltvEventInterval,
        });
    }
    // defer loading CIO until tracking something
    initCustomerio(data);

    tracking.identify();
};

/**
 * Track a Google Tag Manager event
 * @param {string} eventName
 * @param {object} propertyData
 */
function trackGTagEvent(eventName, propertyData) {
    if (!window.dataLayer) {
        loadGoogleTagManager();
    }

    const gtagValuePrefix = 'gtag_value__';
    const gtagEventName = eventName.replace('gtag__', '');
    const gtagParams = Object.entries(propertyData)
        .filter(([key]) => key.indexOf(gtagValuePrefix) === 0)
        .reduce((accumulator, [key, value]) => {
            accumulator[key.replace(gtagValuePrefix, '')] = value;
            return accumulator;
        }, {});
    const params = {
        event: gtagEventName,
        ...gtagParams,
    };

    window.dataLayer.push(params);
    analyticsLog('track:gtag', params);
}

/**
 * Track an event
 * @param {String} eventName
 * @param {Object} propertyData
 * @param {Object} [options]
 *      @property {Array.<String>} [options.exclude] Destinations to exclude
 */
tracking.track = (eventName, propertyData, options = {}) => {
    const defaultOptions = {
        exclude: [],
    };
    options = _.extend({}, defaultOptions, options);

    if (window.nativeAnalyticsDisabled) {
        return;
    }

    // TODO generate this in Python using analytics.utils.get_abbreviated_action
    let { action } = propertyData;
    if (propertyData.suffix != null && typeof action !== 'undefined') {
        action += propertyData.suffix;
    }

    // Useful for things like Google Analytics which allow two levels of hierarchy, and no
    // arbitrary attributes.
    if (typeof action === 'undefined') {
        action = 'none';
    }

    const path = window.location.pathname;
    const pathData = {
        full_path: path + window.location.search,
        path,
    };

    const allPropertyData = Object.assign(
        {},
        pathData,
        tracking.superProperties,
        tracking.temporaryProperties,
        propertyData,
    );

    // Track continue practicing banner
    if (eventName === 'sign_of_life') {
        allPropertyData.displayed_continue_practicing_banner =
            tracking.displayedContinuePracticingBanner;
        allPropertyData.displayed_recommended_course_banner =
            tracking.displayedRecommendedCourseBanner;

        if (tracking.displayedContinuePracticingBanner) {
            const data = jqGetElemById('continue-practicing-notif').data();
            if (data) {
                allPropertyData.continue_practicing_quiz_id = data.targetQuizId;
                allPropertyData.continue_practicing_lesson_id = data.targetLessonId;
                allPropertyData.continue_practicing_problems_left = data.problemsLeft;
            }
        }
        if (tracking.displayedRecommendedCourseBanner) {
            allPropertyData.recommended_course_id = tracking.recommendedCourseId;
        }

        Object.assign(allPropertyData, {
            window_width: $window.width(),
            window_height: $window.height(),
            screen_width: window.screen.width,
            screen_height: window.screen.height,
        });
    }

    // Track gtag events separately
    if (eventName.indexOf('gtag__') >= 0) {
        trackGTagEvent(eventName, allPropertyData);
        delete propertyData.gtag_value;
        return;
    }

    analyticsLog('track', eventName, action, allPropertyData);

    if (tracking.analyticsLive) {
        // Segment
        const integrations = { All: true };
        options.exclude.forEach(dest => integrations[dest] = false);
        try {
            segmentanalytics.track(eventName, allPropertyData, { integrations });
        } catch (e) {
            // do nothing
        }

        // Google Analytics
        if (window.ga && eventName !== 'sign_of_life' && eventName !== 'ui') {
            window.ga('send', 'event', eventName, action);
        }

        // Customer.io
        // not sure what happens if you track a nobody
        if (tracking.cioIdentifyData.created_at && eventName === 'ui') {
            // eslint-disable-next-line no-underscore-dangle
            window._cio.track(eventName, allPropertyData);
            loadCustomerio();
        }
    }
};

/**
 * This is a facade between Avo and our existing tracking code. Avo will call
 * `AvoInterop.make(...)` on init, and `AvoInterop.logEvent(event, properties)` whenever any of the
 * specific tracking methods are called on Avo (eg. `Avo.searchResult(properties)`).
 * None of the other methods are used at this time, but the docs specify them.
 */
const AvoInterop = {
    make: function(env) {
    },

    logEvent: tracking.track,

    setUserProperties: function(userId, userProperties) {
    },

    identify: function(userId) {
    },

    unidentify: function() {
    },
}

/**
 * Set super properties in Segment
 * @param {Object} super_properties
 */
tracking.setSuperProperties = function (newSuperProperties) {
    analyticsLog('setSuperProperties', newSuperProperties);
    if (tracking.analyticsLive) {
        tracking.superProperties = _.extend({}, tracking.superProperties, newSuperProperties);
    }
};

/**
 * Set temporary properties
 * @param {Object} properties - new properties, will override existing temp properties
 */
tracking.setTemporaryProperties = function (properties) {
    tracking.temporaryProperties = _.extend({}, tracking.temporaryProperties, properties);
};

/**
 * Identify a user
 */
tracking.identify = function () {
    if (tracking.analyticsLive) {

        if (tracking.userIsAuthenticated) {
            segmentanalytics.identify(tracking.identity, tracking.userProperties);
            analyticsLog('identify:segment/all', tracking.identity, tracking.userProperties);
            tatariIdentify(tracking.identity);
        } else {
            // No user id for logged out amplitude. This lets amplitude merge logged-out events
            // into an existing user once the user logs in.
            segmentanalytics.identify(null, tracking.userProperties, {
                integrations: {
                    All: false,
                    Amplitude: true,
                },
            });
            analyticsLog('identify:segment/amplitude', null, tracking.userProperties);

            // Send user id for everyone else (Kinesis)
            segmentanalytics.identify(tracking.identity, tracking.userProperties, {
                integrations: {
                    All: true,
                    Amplitude: false,
                },
            });
            analyticsLog('identify:segment/all', tracking.identity, tracking.userProperties);
        }

        // Customer.io - This is here because we don't want people_set every request, but we need
        // identify every request. If there is no identity, we do not want to send anything to
        // customer.io for fear of random people getting emailed.
        if (tracking.cioIdentifyData.created_at) {
            var cio_data = {};
            for (var key in tracking.cioIdentifyData) {
                cio_data[key] = tracking.cioIdentifyData[key];
            }
            for (var key in tracking.superProperties) {
                cio_data[key] = tracking.superProperties[key];
            }
            var userAgentLower = navigator.userAgent.toLowerCase();
            if (userAgentLower.indexOf('android') !== -1) {
                cio_data.ever_visited_with_android = true;
            }
            if ((/iphone|ipad/gi).test(userAgentLower) !== -1) {
                cio_data.ever_visited_with_ios = true;
            }
            if (isAndroid) {
                cio_data.has_installed_android_app = true;
            }
            if (isIos) {
                cio_data.has_installed_ios_app = true;
            }
            window._cio.identify(cio_data)
            analyticsLog('identify:cio', cio_data);
        }
    }
}

/**
 * Track buttons in app webviews
 * @param {JQuery} $btn
 */
tracking.trackNativeBtn = function ($btn) {
    $btn.on('click', function () {
        var cleanUrl = function (url) {
            return url.split('?')[0];
        };

        var data = $btn.data();

        delete data.controller;
        data.target = cleanUrl(data.target);
        data.from = cleanUrl(data.from);

        tracking.track('mobile_native_ui', data);
    });
};

/**
 * Only track an event once for a given element
 * @param {HTMLElement} element
 * @param {String} event_key
 * @param {String} event_name
 * @param {Object} event_params
 */
var analytics_track_once = function (element, event_key, event_name, event_params) {
    var $element = $(element);
    if (!$element.data('sent_' + event_key)) {
        tracking.track(event_name, event_params);
        $element.data('sent_' + event_key, true);
    }
};

/**
 * Add click events to ax-click buttons/links
 * @param {JQuery} [$root]
 */
tracking.setAnalyticsEvents = ($root) => {
    $root = $root || $('body');
    $root.find('.ax-click').on('click.axclick', function (e) {
        var $this = $(this),
            data = $this.data(),
            required_class = data.axRequire,
            forbidden_class = data.axForbid,
            only_once = $this.hasClass('ax-once');

        // only create this event once to avoid tracking
        // a single event multiple times
        if (data.ax_active === true) {
            return;
        }
        $this.data('ax_active', true);

        if (!data.axId) {
            return;
        }


        if (required_class && !$this.hasClass(required_class)) {
            return;
        }

        if (forbidden_class && $this.hasClass(forbidden_class)) {
            return;
        }

        var event_params = {
            element_type: data.axType,
            element_id: data.axId,
            path: window.location.pathname,
            full_path: window.location.pathname + window.location.search
        };

        // If ax-action is specified use it, otherwise use action = click'
        event_params.action = data.axAction ? data.axAction : 'click';

        if (data.gifUrl) {
            event_params.gif_content = data.gifContent;
        }

        if (only_once) {
            analytics_track_once(this, 'click_analytics', 'ui', event_params);
        } else {
            tracking.track('ui', event_params);
        }
    });
};


/**
 * Add event to FaceBook Pixel
 * @param {boolean} isCustom
 * @param {string} eventName
 * @param {string} eventObj
 */
tracking.trackFacebookPixel = function (isCustom, eventName, eventObj) {
    if (window.fbq) {
        window.fbq(isCustom ? 'trackCustom' : 'track', eventName, eventObj || {});
    }
};

/**
 * Add event to FaceBook and Google Pixel
 * @param {JQuery} $container
 */
tracking.trackPixelController = function ($container) {
    var data = $container.data();
    if (!data.tracked) {
        _.defer(function () {
            if (data.facebookEventName) {
                tracking.trackFacebookPixel(true, data.facebookEventName, {
                    slug: data.slug
                });
            }
            if (data.googleLabelRemarketing) {
                trackGooglePixel({
                    google_conversion_label: data.googleLabelRemarketing
                }, true);
            }
            if (data.googleLabelConversions) {
                trackGooglePixel({
                    google_conversion_label: data.googleLabelConversions
                });
            }
        });

        $container.data('tracked', 'true');
        $container.attr('data-tracked', 'true');    // updating attr so that html gets updated too
    }
};

tracking.setAnalyticsEvents();

// export for visualizations
window.banalytics = tracking;

module.exports = tracking;
